module.exports = __webpack_public_path__ + "img/organ4.c8bbb2e.png";